import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { GetLoginAnnouncementTableData } from '@/modules/client-setting/type'
import LoginAnnounceTable from '../LoginAnnounceTable'
import CreateLoginAnnounceModal from '../CreateLoginAnnounceModal'

interface LoginAnnounceListingProps {
	data: GetLoginAnnouncementTableData[]
	isLoading?: boolean
}

export default function LoginAnnounceListing({
	data,
	isLoading,
}: LoginAnnounceListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading title={`รายการประกาศ`} description="รายการประกาศ" />
				<CreateLoginAnnounceModal />
			</div>
			<Separator />
			<LoginAnnounceTable data={data} isLoading={isLoading} />
		</div>
	)
}
